import classNames from 'classnames';
import React from 'react';

const Item = ({ status }: { status: 'critical' | 'info' }) => {
  const customStatus = {
    critical: status === 'critical',
    info: status === 'info'
  };
  return (
    <div
      className={classNames(
        'mb-3 interview-item px-4 py-2 rounded',
        customStatus
      )}
    >
      <div className="d-flex justify-content-between">
        <div className="d-flex align-items-center">
          <span className={classNames('interview-disc', customStatus)} />
          <small className="fw-bold ms-1">8:00-8:30</small>
        </div>
      </div>
      <p className="m-0 text-body-tertiary">1st Interview: Mike c.</p>
    </div>
  );
};

function InterviewList() {
  return (
    <div>
      <Item status="critical" />
      <Item status="info" />
      <Item status="info" />
      <Item status="info" />
      <Item status="info" />
      <Item status="critical" />
      <Item status="info" />
      <Item status="critical" />
      <Item status="info" />
      <Item status="info" />
    </div>
  );
}

export default InterviewList;
